import Router from "@/common/router/Router";

export default class SensorTagRouter extends Router {
  static BASE_PATH = "/sensor_tag";
  static SHOW_ROUTE_NAME = "sensor_tag_show";
  static CREATE_ROUTE_NAME = "sensor_tag_create";
  static UPDATE_ROUTE_NAME = "sensor_tag_update";
  static LIST_ROUTE_NAME = "sensor_tag_list";

  constructor() {
    super(
      SensorTagRouter.BASE_PATH,
      SensorTagRouter.SHOW_ROUTE_NAME,
      SensorTagRouter.CREATE_ROUTE_NAME,
      SensorTagRouter.UPDATE_ROUTE_NAME,
      SensorTagRouter.LIST_ROUTE_NAME
    );
  }
}

export const sensorTagRouter = new SensorTagRouter();
